import UI from '../ui';
import HotelSearch from '../components/HotelSearch';

type component = {
  title: string
  Render: React.FC
};

const components: component[] = [
  {
    title: 'Carousel',
    Render: () => {
      return (
        <UI.Carousel>
          <img
            src="/hotels/spain.png"
            style={{
              borderRadius: '5px',
              maxHeight: '300px',
              objectFit: 'cover',
            }}
          />
          <img
            src="/hotels/greece.png"
            style={{
              borderRadius: '5px',
              maxHeight: '300px',
              objectFit: 'cover',
            }}
          />
        </UI.Carousel>
      );
    },
  },
  {
    title: 'Accordions',
    Render: () => {
      return (
        <UI.AccordionGroup
          items={[
            { label: '1', content: 'ONE' },
            { label: '2', content: 'TWO' },
            { label: '3', content: 'THREE' },
          ]}
        />
      );
    },
  },
  {
    title: 'Hotel Search',
    Render: () => {
      return <HotelSearch country="KW" onSelectedHotel={({ name }) => console.log(name)} />;
    },
  },
];
const CheatSheetPage: React.FC = () => {
  return (
    <UI.VerticalLayout gap={20}>
      {components.map(({ title, Render }, i) => (
        <UI.VerticalLayout key={i} gap={5}>
          <UI.Text size="title">{title}</UI.Text>
          <Render />
        </UI.VerticalLayout>
      ))}
    </UI.VerticalLayout>
  );
};

export default CheatSheetPage;
